import axios from "axios";

// const localURL = "http://localhost:3010/";
// const cloudURL = "https://node-ticycles-warranty.vercel.app/";
const cloudURL = "https://backend.feostech.com/";
// const cloudURL = "http://ec2-34-204-214-175.compute-1.amazonaws.com:3010/";
// const cloudURL = "http://localhost:3010/";
export const APICall = axios.create({
  baseURL: cloudURL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json", // Default Content-Type
  },
});
